import isEmpty from 'lodash/isEmpty'
import React, { FC } from 'react'

import { Chip, ChipProps } from '@Components/Chips/Chip/Chip'
import { useTranslation } from '@Globals/Translations'

interface DiscountProps extends ChipProps {
  discount: {
    context?: string
    percentage?: number
  }
}

export const getColor = (type: string) => {
  switch (type) {
    case 'black_friday':
    case 'black_week':
    case 'cyber_monday':
      return 'black'
    case 'outlet':
      return 'red'

    default:
      if (type.toLowerCase().includes('valentine_a_small')) {
        return 'valentine_a_small'
      }
      if (type.toLowerCase().includes('valentine_a_large')) {
        return 'valentine_a_large'
      }
      if (type.toLowerCase().includes('valentine_a')) {
        return 'valentine_a_small'
      }
      if (type.toLowerCase().includes('valentine_b_small')) {
        return 'valentine_b_small'
      }
      if (type.toLowerCase().includes('valentine_b_large')) {
        return 'valentine_b_large'
      }
      if (type.toLowerCase().includes('valentine_b')) {
        return 'valentine_b_small'
      }
      if (type.toLowerCase().includes('blacksale')) {
        return 'blacksale'
      }
      if (type.toLowerCase().includes('trendhimclubexclusive')) {
        return 'trendhimclubexclusive'
      }
      if (type.toLowerCase().includes('lateseasonsalesvg')) {
        return 'lateseasonsalesvg'
      }
      if (type.toLowerCase().includes('lateseasonsale')) {
        return 'lateseasonsale'
      }
      if (type.toLowerCase().includes('summer')) {
        return 'summersale'
      }
      if (type.toLowerCase().includes('sale')) {
        return 'sale'
      }
      return isEmpty(type) ? 'red' : type
  }
}

const legacyWordbook = (context: string) => {
  switch (context) {
    case 'bundle_offer':
      return 'common:BUNDLE_OFFER_PRODUCT_TAG'
    case 'outlet':
      return 'outlet'
    default:
      return ''
  }
}

const LegacyDiscountChip: FC<DiscountProps> = ({
  discount,
  size = 'medium',
}) => {
  const { t } = useTranslation()
  const {
    context = '',
    percentage = 0,
  } = discount

  const label = t(legacyWordbook(context))

  if (!label) {
    return null
  }

  const color = getColor(context)
  const isDiscount = (percentage || 0) > 0
  const percentageLabel = isDiscount ? `-${percentage}%` : ''
  const separator = label !== '' && isDiscount ? ' ' : ''

  return (
    <Chip color={color} size={size}>
      {color === 'red' ? `${label}${separator}${percentageLabel}` : `${percentageLabel}${separator}${label}`}
    </Chip>
  )
}

export const DiscountChip: FC<DiscountProps> = ({
  discount,
  size = 'medium',
}) => {
  const { t } = useTranslation()

  const {
    context = '',
    percentage = 0,
  } = discount
  const label = t('common:discount_chip', {
    context,
    discountPercentage: percentage,
  })
  const color = getColor(context)
  if (label === 'discount_chip') {
    return <LegacyDiscountChip discount={discount} size={size} />
  }

  if (!label) {
    return null
  }

  return (
    <Chip color={color} size={size}>
      {label}
    </Chip>
  )
}

